import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'ras-dropdown',
	templateUrl: './dropdown.component.html',
	styleUrls: ['./dropdown.component.sass']
})
export class DropdownComponent implements OnInit {

	@Input() options: any[]
	@Input() value: any = null
	@Output() valueChange = new EventEmitter<any>()
	@Input() label: string
	@Input() valid: boolean = true

	public open = false

	constructor() { }

	ngOnInit(): void {
	}

	select(option: any) {
		if (this.value !== option) {
			this.valueChange.emit(option)
		}
		this.open = false
	}

}
